import e,{useCallback as t,useRef as r}from"react";import n from"../utils/styled.js";import{Spinner as i}from"@blueprintjs/core";import{registerNextDomDrop as o}from"../canvas/page.js";const a=n("div")`
  height: 100%;
  overflow: auto;
`,l=n("div")`
  width: 50%;
  float: left;
`,c=n("div")`
  padding: 5px;
  width: 100%;
  &:hover .video-grid__item-credit {
    opacity: 1;
  }
`,d=n("div")`
  position: relative;
`,s=n("video",e.forwardRef)`
  width: 100%;
  cursor: pointer;
  display: block;
  max-height: 300px;
  min-height: 50px;
  object-fit: cover;
  border-radius: 5px;
  box-shadow: 0 0 5px rgba(16, 22, 26, 0.3);
`,u=n("div")`
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  background-color: rgba(0, 0, 0, 0.5);
  color: white;
  padding: 2px 7px;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 4rem;
`,g=n("span")`
  font-size: 12px;
`,m=n("div",e.forwardRef)`
  padding: 3rem;
`,p=n("div")`
  position: absolute;
  opacity: 0;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 3px;
  background: linear-gradient(
    to bottom,
    rgba(0, 0, 0, 0),
    rgba(0, 0, 0, 0.4),
    rgba(0, 0, 0, 0.6)
  );
  color: white;
  font-size: 10px;
  text-align: center;
`;export const VideosGrid=({items:n,onSelect:c,loadMore:d,isLoading:s,error:u,getCredit:g})=>{const p=r(null),f=t(e=>{s||(p.current&&p.current.disconnect(),p.current=new IntersectionObserver(e=>{e[0].isIntersecting&&d()}),e&&p.current.observe(e))},[s]);if(u){return e.createElement("div",null,u.message)}if(!n||0===n.length){return null}const b=n.filter((e,t)=>t%2==1),h=n.filter((e,t)=>t%2==0);return e.createElement(a,null,[b,h].map((t,r)=>e.createElement(l,{key:r},t.map(t=>e.createElement(v,{key:t.id,item:t,onClick:()=>c(t),onDragStart:e=>{o((e,r)=>{c(t,e,r)})},onDragEnd:()=>o(null),getCredit:g})),e.createElement(m,{ref:f},s&&e.createElement(i,null)))))};const v=({item:t,onClick:n,onDragEnd:i,onDragStart:o,getCredit:a})=>{var l;const m=r(null),v=(null===(l=t.video_files.find(e=>"sd"===e.quality))||void 0===l?void 0:l.link)||"";if(!v){return null}const f=new Date(1e3*t.duration).toISOString();let b;return b=t.duration>3600?f.substring(11,19):f.substring(14,19),e.createElement(c,null,e.createElement(d,{draggable:!0,onClick:n,onDragEnd:i,onDragStart:o,onMouseEnter:()=>{var e;null===(e=m.current.play())||void 0===e||e.catch(()=>{})},onMouseLeave:()=>{var e;null===(e=m.current.pause())||void 0===e||e.catch(()=>{}),m.current.currentTime=0}},e.createElement(s,{poster:t.video_pictures[0].picture,controls:!1,ref:m,muted:!0,preload:"none",playsInline:!0},e.createElement("source",{src:v})),e.createElement(u,null,e.createElement(g,null,b)),a&&e.createElement(p,{className:"video-grid__item-credit"},a(t))))};